module.exports = __webpack_public_path__ + "static/media/IMG_4520 from lounge.2052950a.JPG";